export enum DayOfWeekEnum {
  NA,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday,
  Sunday
}

export namespace DayOfWeekEnum {
  export function values() {
    return Object.keys(DayOfWeekEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
